import { api } from "./authService"

export const getAllSensitiveTools = async (): Promise<string[]> => {
	try {
		const { data } = await api.get<{ data: string[] }>("/tools/sensitive-tools")
		return data.data
	} catch (_error) {
		throw new Error("Error fetching all sensitive tools")
	}
}
